import React from 'react';
import GaiLogo from '../../images/logo_300x129_transparent.png';
import {Divider, Box, Flex, Image, useColorModeValue, Button, Menu, MenuButton, MenuList, Text, Spacer} from '@chakra-ui/react';
import {Heading} from '@chakra-ui/react';
import NavItems from './NavItems';
import {FaBars} from 'react-icons/fa';
import UserWidget from './UserWidget';
// import {useLocation} from 'react-router-dom';

// This is called in the Router.js file
const TopMenu = props => {
  return (
    <Box>
      <Flex bg={useColorModeValue('tertiary.50', 'gray.700')} flexDir={{base: 'column', md: 'row'}}>
        <Image mx={'30'} my="3" src={GaiLogo} maxW={{base: 'md', md: 'sm'}} />
        <Flex>
          <Heading ml={{base: '40', md: '10'}} alignSelf="center">
            {props.title}
          </Heading>
          <Spacer />
          <Box display={{base: 'block', md: 'none'}} alignSelf="end" mr="10">
            <Menu>
              <MenuButton as={Button} color={'gray.500'}>
                <FaBars />
              </MenuButton>

              <MenuList px="3">
                <NavItems screens={props.screens} parent={props.parent} />
                <UserWidget navSize={'large'} />
              </MenuList>
            </Menu>
          </Box>
        </Flex>
        <Spacer />
        <Box flex="1" alignContent={'center'} alignSelf="center">
          <Heading size="md" mb="3">
            Survey Management System
          </Heading>
          <Heading size="md">Funeral Service Research Group®</Heading>
        </Box>
      </Flex>
      <Divider />
    </Box>
  );
};

export default TopMenu;
